import { Component, ChangeDetectionStrategy, OnInit } from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { filter } from 'rxjs/operators';

declare const hj: Function;

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [RouterOutlet]
})
export class AppComponent implements OnInit {
  title = 'app-management';

  constructor(private router: Router) {
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event) => {
        if (typeof hj !== 'undefined') {
          hj('stateChange', (event as NavigationEnd).urlAfterRedirects);
        }
      });
  }

  ngOnInit(): void {
    this.observeSwalContainers();
  }

  private observeSwalContainers(): void {
    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        mutation.addedNodes.forEach((node) => this.promoteSwalContainerToTopLayer(node));
      }
    });
    observer.observe(document.body, { childList: true });
  }

  private promoteSwalContainerToTopLayer(node: Node): void {
    if (!(node instanceof HTMLElement)) return;
    const container = node.classList.contains('swal2-container') ? node : node.querySelector?.('.swal2-container');
    if (container instanceof HTMLElement && 'showPopover' in container && !container.hasAttribute('popover')) {
      container.setAttribute('popover', 'manual');
      (container as any).showPopover();
    }
  }
}
